var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['search-locator-map', { 'loading': _vm.isStatus('loading'), 'is-empty': _vm.items.length === 0 }]})}
var staticRenderFns = []

export { render, staticRenderFns }